<template>
    <invitations-current>
        <div slot-scope="{ data: invitation }">
            <div class="container mx-auto max-w-2xl px-6 pt-6 pb-12 md:p-12 md:pb-24">
                <div class="flex flex-col-reverse md:flex-row py:12">
                    <div class="flex-none flex items-center md:py-6 lg:py-12">
                        <div class="text-center md:text-left md:max-w-sm md:-mt-3">
                            <h1 class="text-2xl lg:text-4xl font-semibold mb-4">
                                Hey, {{ invitation.to_name }}.<br>
                                <span class="text-blue text-xl sm:text-2xl lg:text-4xl">Welcome to Rentora.</span>
                            </h1>

                            <div class="mb-6 px-1/12 sm:px-2/12 md:px-0 md:max-w-xs">
                                <h2 class="text-grey-darker font-normal text-base lg:text-lg mb-3">
                                    {{ invitation.from_name }} thought Rentora might be of interest to you,
                                    so sent this invitation.
                                </h2>
                            </div>

                            <div class="inline-flex">
                                <laroute-link
                                    :to="{ name: 'auth.users.create' }"
                                    class="btn btn-blue btn-lg shadow mr-3"
                                >
                                    Try For Free
                                </laroute-link>

                                <router-link
                                    :to="{ name: 'www.demo.index' }"
                                    class="btn btn-lg btn-with-icon btn-blue-lightest shadow inline-flex items-center"
                                >
                                    <base-svg
                                        name="icon-play"
                                        class="w-6 h-6 fill-primary-blue fill-secondary-blue-lighter mr-2"
                                    />

                                    Demo
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="flex-grow flex items-center justify-center mb-6 md:mb-0">
                        <base-svg
                            name="illustration-devices"
                            class="w-full sm:max-w-xs md:max-w-sm"
                        />
                    </div>
                </div>
            </div>
        </div>
    </invitations-current>
</template>

<script>
    import InvitationsCurrent from '../../components/invitations-current'

    export default {
        components: {
            InvitationsCurrent
        }
    }
</script>
